// @flow
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { FormattedMessage, IntlShape, injectIntl } from 'react-intl';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';
import points11Messages from 'esm-web-pro/messages/points11Messages';
import points10Messages from 'esm-web-pro/messages/points10Messages';

type Props = {
    line: Object,
    url: string,
    intl: IntlShape,
    onView: Function,
}


const GisLineAttributes = (props: Props) => {
    const {
        line, url, intl: { formatMessage }, onView,
    } = props;
    const location = useLocation();
    const {
        start_point: startContainerPoint, end_point: endContainerPoint, length,
        project,
    } = line;

    const getPointAttributeValues = (point) => (point.point ? {
        value: `${formatMessage(points11Messages[point.point.type])} ${
            point.point.type === 'pop' && point.alias
                ? point.alias
                : point.sequence
        }`,
        link: `${url.split('/layer')[0]}/layer/${point.point.type}/${point.point.identity}`,
    } : {
        value: `${formatMessage(points10Messages.gispoint)} ${point.sequence}`,
        link: `${url.split('/layer')[0]}/layer/gispoint/${point.identity}`,
    });

    const attributes = [
        {
            label: formatMessage(attributeMessages.provider),
            value: line.infrastructure_provider?.entity.name,
        },
        {
            label: formatMessage(attributeMessages.ref),
            value: line.ref,
            onClick: onView,
        },
        {
            label: formatMessage(attributeMessages.start),
            ...getPointAttributeValues(startContainerPoint),
        },
        {
            label: formatMessage(attributeMessages.end),
            ...getPointAttributeValues(endContainerPoint),
        },
        {
            label: <FormattedMessage id="gisline-attributes-length" defaultMessage="Length" />,
            value: <FormattedMessage
                id="gisline-attributes-length-value"
                defaultMessage="{value} m."
                values={{ value: length }}
            />,
        },
    ];

    if (project) {
        attributes.push({
            label: formatMessage(attributeMessages.project),
            value: project.project,
            link: `/projects/${project.project_uuid}/dashboard/stages`,
        });

        attributes.push({
            label: formatMessage(attributeMessages.projectStage),
            value: project.project_stage,
            link: `/projects/${project.project_uuid}/dashboard/stages/quick-view/${project.project_stage_uuid}`,
        });
        attributes.push({
            label: formatMessage(attributeMessages.buildingStatus),
            value: project.stage,
        });
    }
    if (line.regions) {
        attributes.push(
            {
                label: (
                    <FormattedMessage
                        id="map-regions"
                        defaultMessage="Regions"
                    />
                ),
                multiValue: line.regions.map((region) => ({
                    value: region.name,
                    link: region.uuid ? `/infrastructure/map/${
                        line.map_identity}/${location.pathname.includes('active')
                        ? 'active' : 'draft'}/layer/region/${
                        region.uuid}` : null,
                })),
                separator: ', ',
            },
        );
    }


    return <Attributes attributes={attributes} />;
};

export default injectIntl(GisLineAttributes);
